export type TUserState = typeof USER_STATE_NAMES[keyof typeof USER_STATE_NAMES];

export const USER_STATE_NAMES = {
    ACTIVE: 'active',
    BLOCKED: 'blocked',
    CLOSE_ONLY: 'close_only',
    DISABLED: 'disabled',
    RESTRICTED: 'restricted',
} as const;
